import { css } from "styled-components";
const colors = {
  white: "#FFFFFF",
  black: "#141414",
  grey15: "#1A222E",
  grey25: "#2E3742",
  grey35: "#475362",
  grey50: "#6F7D90",
  grey60: "#8D9AAC",
  grey80: "#D4DAE3",
  grey90: "#E5EAF0",
  grey92: "#EEF1F6",
  grey95: "#F5F7FA",
  brand950: "#1F003B",
  brand900: "#2E0057",
  brand800: "#4C008F",
  brand700: "#6A00C7",
  brand600: "#8800FF",
  brand500: "#9A3BFF",
  brand400: "#AF73FF",
  brand300: "#C8A6FF",
  brand200: "#DECDFF",
  brand100: "#EEE4FF",
  brand50: "#F5F0FF",
  blue15: "#032A53",
  blue25: "#0D3E72",
  blue35: "#1E5A99",
  blue50: "#2974C4",
  blue60: "#5094DC",
  blue80: "#A3CBF5",
  blue95: "#F1F7FE",
  green15: "#02503D",
  green25: "#0F7158",
  green35: "#1D9071",
  green50: "#3AA186",
  green60: "#66CAA4",
  green80: "#90E0BE",
  green95: "#EBFEF9",
  red15: "#5C0000",
  red25: "#731111",
  red35: "#9B2222",
  red50: "#CB3434",
  red60: "#DC4C4C",
  red80: "#F6B2B2",
  red95: "#FDF2F2",
  purple15: "#500052",
  purple25: "#770079",
  purple35: "#8E2390",
  purple50: "#BB58BC",
  purple60: "#CC73CE",
  purple80: "#E7B7E7",
  purple95: "#FEF5FE",
  pink15: "#5B0122",
  pink25: "#7F0532",
  pink35: "#A5184B",
  pink50: "#D12E69",
  pink60: "#EF5D92",
  pink80: "#F5ADC7",
  pink95: "#FEF1F6",
  yellow15: "#4D2900",
  yellow25: "#855200",
  yellow35: "#C07E02",
  yellow50: "#E69C24",
  yellow60: "#FCB226",
  yellow80: "#FDC65E",
  yellow95: "#FFF8EB",
  lightBlue00: "#7E96B2",
  transparent0: "rgba(0,0,0,0)",
  transparent5: "rgba(49, 77, 123, 0.05)",
  transparent10: "rgba(49, 77, 123, 0.1)",
  black0t32: "color-mix(in srgb, #141414, transparent 68%)",
  bgDefault: "var(--bg-default)",
  bgSubtle: "var(--bg-subtle)",
  bgOverlay: "var(--bg-overlay)",
  bgInverted: "var(--bg-inverted)",
  bgInvertedSubtle: "var(--bg-inverted-subtle)",
  surfaceDefault: "var(--surface-default)",
  surfaceDefaultSubtle: "var(--surface-default-subtle)",
  surfaceHover: "var(--surface-hover)",
  surfaceSelected: "var(--surface-selected)",
  surfaceDisabled: "var(--surface-disabled)",
  surfaceActive: "var(--surface-active)",
  surfaceInverted: "var(--surface-inverted)",
  surfaceInvertedSubtle: "var(--surface-inverted-subtle)",
  surfaceInvertedHover: "var(--surface-inverted-hover)",
  surfaceInvertedSelected: "var(--surface-inverted-selected)",
  surfaceInvertedDisabled: "var(--surface-inverted-disabled)",
  surfaceInvertedActive: "var(--surface-inverted-active)",
  surfaceActionPrimary: "var(--surface-action-primary)",
  surfaceActionPrimaryHover: "var(--surface-action-primary-hover)",
  surfaceActionPrimaryPressed: "var(--surface-action-primary-pressed)",
  surfaceActionPrimaryFocused: "var(--surface-action-primary-focused)",
  surfaceActionPrimaryDisabled: "var(--surface-action-primary-disabled)",
  surfaceActionPrimarySelected: "var(--surface-action-primary-selected)",
  surfaceActionSecondary: "var(--surface-action-secondary)",
  surfaceActionSecondaryHover: "var(--surface-action-secondary-hover)",
  surfaceActionSecondaryPressed: "var(--surface-action-secondary-pressed)",
  surfaceActionSecondaryFocused: "var(--surface-action-secondary-focused)",
  surfaceActionSecondaryDisabled: "var(--surface-action-secondary-disabled)",
  surfaceActionSecondarySelected: "var(--surface-action-secondary-selected)",
  surfaceActionTertiary: "var(--surface-action-tertiary)",
  surfaceActionTertiaryHover: "var(--surface-action-tertiary-hover)",
  surfaceActionTertiaryPressed: "var(--surface-action-tertiary-pressed)",
  surfaceActionTertiaryFocused: "var(--surface-action-tertiary-focused)",
  surfaceActionTertiaryDisabled: "var(--surface-action-tertiary-disabled)",
  surfaceActionTertiarySelected: "var(--surface-action-tertiary-selected)",
  surfaceActionGhost: "var(--surface-action-ghost)",
  surfaceActionGhostHover: "var(--surface-action-ghost-hover)",
  surfaceActionGhostPressed: "var(--surface-action-ghost-pressed)",
  surfaceActionGhostFocused: "var(--surface-action-ghost-focused)",
  surfaceActionGhostDisabled: "var(--surface-action-ghost-disabled)",
  surfaceActionGhostSelected: "var(--surface-action-ghost-selected)",
  surfaceActionDelete: "var(--surface-action-delete)",
  surfaceActionDeleteHover: "var(--surface-action-delete-hover)",
  surfaceActionDeletePressed: "var(--surface-action-delete-pressed)",
  surfaceActionDeleteFocused: "var(--surface-action-delete-focused)",
  surfaceActionDeleteDisabled: "var(--surface-action-delete-disabled)",
  surfaceActionDeleteSelected: "var(--surface-action-delete-selected)",
  surfaceActionBrand: "var(--surface-action-brand)",
  surfaceActionBrandHover: "var(--surface-action-brand-hover)",
  surfaceActionBrandPressed: "var(--surface-action-brand-pressed)",
  surfaceActionBrandFocused: "var(--surface-action-brand-focused)",
  surfaceActionBrandDisabled: "var(--surface-action-brand-disabled)",
  surfaceActionBrandSelected: "var(--surface-action-brand-selected)",
  surfaceStatusNeutral: "var(--surface-status-neutral)",
  surfaceBrand: "var(--surface-brand)",
  surfaceBrandStrong: "var(--surface-brand-strong)",
  surfaceInfo: "var(--surface-info)",
  surfaceInfoStrong: "var(--surface-info-strong)",
  surfaceSuccess: "var(--surface-success)",
  surfaceSuccessStrong: "var(--surface-success-strong)",
  surfaceWarning: "var(--surface-warning)",
  surfaceError: "var(--surface-error)",
  surfaceScenario: "var(--surface-scenario)",
  textDefault: "var(--text-default)",
  textModerate: "var(--text-moderate)",
  textSubtle: "var(--text-subtle)",
  textDisabled: "var(--text-disabled)",
  textOnInverted: "var(--text-on-inverted)",
  textOnInvertedSubtle: "var(--text-on-inverted-subtle)",
  textOnInvertedStrong: "var(--text-on-inverted-strong)",
  textOnInvertedDisabled: "var(--text-on-inverted-disabled)",
  textAction: "var(--text-action)",
  textActionHover: "var(--text-action-hover)",
  textActionPressed: "var(--text-action-pressed)",
  textActionDisabled: "var(--text-action-disabled)",
  textBrand: "var(--text-brand)",
  textBrandLight: "var(--text-brand-light)",
  textInfo: "var(--text-info)",
  textSuccess: "var(--text-success)",
  textWarning: "var(--text-warning)",
  textError: "var(--text-error)",
  icon: "var(--icon)",
  iconStrong: "var(--icon-strong)",
  iconOnInverted: "var(--icon-on-inverted)",
  iconOnInvertedStrong: "var(--icon-on-inverted-strong)",
  iconOnInvertedSubtle: "var(--icon-on-inverted-subtle)",
  iconAction: "var(--icon-action)",
  iconActionHover: "var(--icon-action-hover)",
  iconActionDisabled: "var(--icon-action-disabled)",
  iconActionActive: "var(--icon-action-active)",
  iconActionActiveHover: "var(--icon-action-active-hover)",
  iconActionActiveDisabled: "var(--icon-action-active-disabled)",
  iconActionBrand: "var(--icon-action-brand)",
  iconActionBrandHover: "var(--icon-action-brand-hover)",
  iconActionBrandDisabled: "var(--icon-action-brand-disabled)",
  iconBrand: "var(--icon-brand)",
  iconInfo: "var(--icon-info)",
  iconSuccess: "var(--icon-success)",
  iconWarning: "var(--icon-warning)",
  iconError: "var(--icon-error)",
  borderSubtle00: "var(--border-subtle00)",
  borderFocus: "var(--border-focus)",
  borderAction: "var(--border-action)",
  borderActionHover: "var(--border-action-hover)",
  borderActionActive: "var(--border-action-active)",
  borderActionDisabled: "var(--border-action-disabled)",
  borderBrand: "var(--border-brand)",
  borderBrandStrong: "var(--border-brand-strong)",
  borderNeutral: "var(--border-neutral)",
  borderInfo: "var(--border-info)",
  borderInfoStrong: "var(--border-info-strong)",
  borderSuccess: "var(--border-success)",
  borderSuccessStrong: "var(--border-success-strong)",
  borderWarning: "var(--border-warning)",
  borderWarningStrong: "var(--border-warning-strong)",
  borderError: "var(--border-error)",
  borderErrorStrong: "var(--border-error-strong)",
  borderDisabled: "var(--border-disabled)",
  componentSwitchSurfaceDefault: "var(--component-switch-surface-default)"
};
const svgDotted = `
<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="2" fill="${colors.transparent5}"/>
        </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#dots)"/>
</svg>`;
const dotted = `url("data:image/svg+xml,${encodeURIComponent(svgDotted)}")`;
const backgroundTokens = {
  dotted
};
const breakpoints = {
  mobile: "0",
  tablet: "740px",
  desktop: "1025px",
  desktopLarge: "1281px",
  desktopXLarge: "1441px"
};
const white = "#FFFFFF";
const black = "#141414";
const brand950 = "#1F003B";
const brand900 = "#2E0057";
const brand800 = "#4C008F";
const brand700 = "#6A00C7";
const brand600 = "#8800FF";
const brand500 = "#9A3BFF";
const brand400 = "#AF73FF";
const brand300 = "#C8A6FF";
const brand200 = "#DECDFF";
const brand100 = "#EEE4FF";
const brand50 = "#F5F0FF";
const grey15 = "#1A222E";
const grey25 = "#2E3742";
const grey35 = "#475362";
const grey50 = "#6F7D90";
const grey60 = "#8D9AAC";
const grey80 = "#D4DAE3";
const grey90 = "#E5EAF0";
const grey92 = "#EEF1F6";
const grey95 = "#F5F7FA";
const blue15 = "#032A53";
const blue25 = "#0D3E72";
const blue35 = "#1E5A99";
const blue50 = "#2974C4";
const blue60 = "#5094DC";
const blue80 = "#A3CBF5";
const blue95 = "#F1F7FE";
const purple15 = "#500052";
const purple25 = "#770079";
const purple35 = "#8E2390";
const purple50 = "#BB58BC";
const purple60 = "#CC73CE";
const purple80 = "#E7B7E7";
const purple95 = "#FEF5FE";
const green15 = "#02503D";
const green25 = "#0F7158";
const green35 = "#1D9071";
const green50 = "#3AA186";
const green60 = "#66CAA4";
const green80 = "#90E0BE";
const green95 = "#EBFEF9";
const yellow15 = "#4D2900";
const yellow25 = "#855200";
const yellow35 = "#C07E02";
const yellow50 = "#E69C24";
const yellow60 = "#FCB226";
const yellow80 = "#FDC65E";
const yellow95 = "#FFF8EB";
const red15 = "#5C0000";
const red25 = "#731111";
const red35 = "#9B2222";
const red50 = "#CB3434";
const red60 = "#DC4C4C";
const red80 = "#F6B2B2";
const red95 = "#FDF2F2";
const pink15 = "#5B0122";
const pink25 = "#7F0532";
const pink35 = "#A5184B";
const pink50 = "#D12E69";
const pink60 = "#EF5D92";
const pink80 = "#F5ADC7";
const pink95 = "#FEF1F6";
const lightBlue00 = "#7E96B2";
const transparent0 = "rgba(0,0,0,0)";
const transparent5 = "rgba(49, 77, 123, 0.05)";
const transparent10 = "rgba(49, 77, 123, 0.1)";
const black0t32 = `color-mix(in srgb, ${black}, transparent 68%)`;
const colorTokens = {
  white,
  black,
  grey15,
  grey25,
  grey35,
  grey50,
  grey60,
  grey80,
  grey90,
  grey92,
  grey95,
  brand950,
  brand900,
  brand800,
  brand700,
  brand600,
  brand500,
  brand400,
  brand300,
  brand200,
  brand100,
  brand50,
  blue15,
  blue25,
  blue35,
  blue50,
  blue60,
  blue80,
  blue95,
  green15,
  green25,
  green35,
  green50,
  green60,
  green80,
  green95,
  red15,
  red25,
  red35,
  red50,
  red60,
  red80,
  red95,
  purple15,
  purple25,
  purple35,
  purple50,
  purple60,
  purple80,
  purple95,
  pink15,
  pink25,
  pink35,
  pink50,
  pink60,
  pink80,
  pink95,
  yellow15,
  yellow25,
  yellow35,
  yellow50,
  yellow60,
  yellow80,
  yellow95,
  lightBlue00,
  transparent0,
  transparent5,
  transparent10,
  black0t32
};
const dashedBlue2 = `2px dashed ${colors.blue60}`;
const dashedGrey1 = `1px dashed ${colors.grey80}`;
const dashedGrey2 = `2px dashed ${colors.grey80}`;
const solidGrey1 = `1px solid ${colors.grey80}`;
const solidLightGrey1 = `1px solid ${colors.grey90}`;
const solid2 = "2px solid";
const lines = {
  /** @color Grey 90 */
  solidLightGrey1,
  /** @color Grey 80 */
  solidGrey1,
  /** @color Grey 80 */
  dashedGrey1,
  /** @color Grey 80 */
  dashedGrey2,
  /** @color Blue 60 */
  dashedBlue2,
  solid2
};
const r4 = "4px";
const r8 = "8px";
const r16 = "16px";
const radius = {
  r4,
  r8,
  r16,
  /** 4 pixels */
  small: r4,
  /** 8 pixels */
  medium: r8,
  /** 16 pixels */
  large: r16,
  /** full circle */
  full: "9999px"
};
const numericSpace = {
  /** 0 */
  none: 0,
  /** 2 */
  xxsmall: 2,
  /** 4 */
  xsmall: 4,
  /** 8 */
  small: 8,
  /** 16 */
  medium: 16,
  /** 24 */
  large: 24,
  /** 32 */
  xlarge: 32,
  /** 64 */
  xxlarge: 64
};
const space = {
  /** 0 pixels */
  none: `${numericSpace.none}`,
  /** 2 pixels */
  xxsmall: `${numericSpace.xxsmall}px`,
  /** 4 pixels */
  xsmall: `${numericSpace.xsmall}px`,
  /** 8 pixels */
  small: `${numericSpace.small}px`,
  /** 16 pixels */
  medium: `${numericSpace.medium}px`,
  /** 24 pixels */
  large: `${numericSpace.large}px`,
  /** 32 pixels */
  xlarge: `${numericSpace.xlarge}px`,
  /** 64 pixels */
  xxlarge: `${numericSpace.xxlarge}px`
};
const shadowM = "0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.14)";
const shadowS = "0px 1px 3px rgba(17, 23, 34, 0.12), 0px 1px 2px rgba(17, 23, 34, 0.06)";
const shadowXS = "0px 1px 2px rgba(58, 5, 58, 0.1)";
const shadowL = "0px 3px 14px 0px rgba(0, 0, 0, 0.1),0px 1px 4px 0px rgba(0, 0, 0, 0.05)";
const shadows = {
  shadowXS,
  shadowS,
  shadowM,
  shadowL
};
const s2_DEPRECATED = "2px";
const s4 = "4px";
const s8 = "8px";
const s12_DEPRECATED = "12px";
const s16 = "16px";
const s24 = "24px";
const s32 = "32px";
const s40_DEPRECATED = "40px";
const s48_DEPRECATED = "48px";
const s56_DEPRECATED = "56px";
const s64 = "64px";
const s80_DEPRECATED = "80px";
const spacing = {
  s2_DEPRECATED,
  s4,
  s8,
  s12_DEPRECATED,
  s16,
  s24,
  s32,
  s40_DEPRECATED,
  s48_DEPRECATED,
  s56_DEPRECATED,
  s64,
  s80_DEPRECATED
};
const timeFast = 150;
const timeDefault = 200;
const timeFastMs = `${timeFast}ms`;
const timeDefaultMs = `${timeDefault}ms`;
const fade = css`
  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
`;
const easings = {
  cubicOut: "cubic-bezier(0.33, 1, 0.68, 1)"
};
const transitionTokens = {
  xsmall: "0.05s",
  small: "0.1s",
  medium: "0.2s",
  large: "0.3s"
};
const easingTokens = {
  cubicOut: easings.cubicOut
};
const vizBlue40 = "#98c0eb";
const vizBlue50 = "#c3daf3";
const vizGray0 = "#fcfcfc";
const vizGray20 = "#dadada";
const vizGreen40 = "#90e9d1";
const vizGreen50 = "#bbf1e3";
const vizPink40 = "#f099b8";
const vizPink50 = "#f7c5d7";
const vizPurple40 = "#e599e6";
const vizPurple50 = "#efc2f0";
const vizRed40 = "#ea9f9f";
const vizRed50 = "#f3c9c9";
const vizYellow40 = "#fed890";
const vizYellow50 = "#feeac3";
const vizFilterGray = "#D4DAE3";
const vizFilterLightGray = "#F7F7F9";
const vizSilver = "#C0C0C0";
const vizSettingsBarGray = "#64747B";
const STACK_PAGE_MANAGER = 9999;
const DATE_PICKER = 5;
const PAGE_HEADER = 6;
const DROPDOWN = 9999;
const MODAL_BACKDROP = 1e5;
const TOOLTIPTEXT = 999999;
const TOAST = STACK_PAGE_MANAGER + 1;
const FAB_CONTAINER = 100;
const VIEW_LEGEND = 999;
const VIEW_SIDE_PANEL = VIEW_LEGEND + 1;
const DETAILS_DRAWER = VIEW_SIDE_PANEL + 1;
const NAV_BAR = 1e5;
const zIndex = {
  STACK_PAGE_MANAGER,
  DROPDOWN,
  TOAST,
  TOOLTIPTEXT,
  MODAL_BACKDROP,
  PAGE_HEADER,
  DATE_PICKER,
  FAB_CONTAINER,
  VIEW_LEGEND,
  VIEW_SIDE_PANEL,
  DETAILS_DRAWER,
  NAV_BAR
};
export {
  backgroundTokens,
  breakpoints,
  colorTokens,
  colors,
  dashedBlue2,
  dashedGrey1,
  dashedGrey2,
  easingTokens,
  fade,
  lines,
  numericSpace,
  r16,
  r4,
  r8,
  radius,
  s12_DEPRECATED,
  s16,
  s24,
  s2_DEPRECATED,
  s32,
  s4,
  s40_DEPRECATED,
  s48_DEPRECATED,
  s56_DEPRECATED,
  s64,
  s8,
  s80_DEPRECATED,
  shadowL,
  shadowM,
  shadowS,
  shadowXS,
  shadows,
  solid2,
  solidGrey1,
  solidLightGrey1,
  space,
  spacing,
  timeDefaultMs,
  timeFastMs,
  transitionTokens,
  vizBlue40,
  vizBlue50,
  vizFilterGray,
  vizFilterLightGray,
  vizGray0,
  vizGray20,
  vizGreen40,
  vizGreen50,
  vizPink40,
  vizPink50,
  vizPurple40,
  vizPurple50,
  vizRed40,
  vizRed50,
  vizSettingsBarGray,
  vizSilver,
  vizYellow40,
  vizYellow50,
  zIndex
};
//# sourceMappingURL=index.js.map
